import { useContext, useLayoutEffect, useRef} from 'react';
import  ToastContext  from './ToastContext';
import { Toast } from 'bootstrap'
import moment from 'moment';

export const ToastComponent = () => {

    const { toast, setToast } = useContext(ToastContext);
    const toastRef = useRef();

    useLayoutEffect(() => {
        let bsToast = Toast.getOrCreateInstance(toastRef.current);

        bsToast._config = { ...bsToast._config, autohide: false }

    }, []
    ) 

    useLayoutEffect(() => {

        if (!toastRef || !toastRef.current) {
            return;
        }

        let bsToast = Toast.getOrCreateInstance(toastRef.current);

        if (toast.length > 0) {

            bsToast.show();

            const timer = setTimeout(() => {
                setToast(toast.filter((x, i) => i > 0))
            }, 10000)

            return () => clearTimeout(timer);
        }
        else {
            bsToast.hide();
        }

    }, [toast]);

    const onHide = () => {

        setToast(toast.filter((x, i) => i > 0))
    }


    let message = {};

    if (toast.length > 0) {

        message = toast[0];
    }

    return <div className="d-flex flex-row-reverse" ><div ref={toastRef} className="toast" role="alert" aria-live="assertive" aria-atomic="true" style={{ position: 'fixed' ,zIndex : 50 }}>
            <div className="toast-header">
            <strong className="me-auto">{message.titre}</strong>
            <small>{ moment(Date.now()).format('LT') }</small>
            <button type="button" className="btn-close"  onClick={ onHide } ></button>
            </div>
            <div className="toast-body">
            <div className={ "alert alert-" + message.severity }>{ message.text }</div>
            </div>
    </div></div>



}